var render = function render(_c, _vm) {
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("owa-usage-messages", {
        attrs: { "message-groups": ["dire"], type: "kit" },
      }),
      _vm._v(" "),
      _c("owa-usage-messages", {
        attrs: { "message-groups": ["dire"], type: "npm", "is-last": "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }